import CreateChannelModal from "./CreateChannelModal";

export default CreateChannelModal;
